/** A body child carrying this attribute stays interactive while a full-screen overlay makes the rest inert. */
export const ABOVE_MODALS_ATTRIBUTE = 'data-above-modals';
